// src/components/AdminRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { isAdmin, loading, error } = useAdmin();
  const { user } = useAuth();

  // Show loading state while checking admin status
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-green-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-green-700 font-medium">Checking admin access...</p>
          <p className="text-sm text-gray-500 mt-2">Verifying your permissions</p>
        </div>
      </div>
    );
  }

  // Show error state if there's an authentication error
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-red-50">
        <div className="text-center">
          <div className="text-red-600 text-4xl mb-4">⚠️</div>
          <p className="text-red-700 font-medium">Authentication Error</p>
          <p className="text-sm text-gray-600 mt-2">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="mt-4 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-all"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // 🚫 If not authenticated, redirect to admin login
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // 🚫 If not admin, redirect to admin login with message
  if (!isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  // ✅ If admin, render protected admin content
  return children;
};

export default AdminRoute;
